// Precache Service Worker
import './helpers/sw-precache-registration';


// Modules
var cache = {};

function importAll(r) {
  r.keys().forEach(function(key) {
    cache[ key ] = r(key);
  });
}

importAll(require.context('../../modules/', true, /^[^\_]*\.js/));

// Scroll to
$(() => {
  // var $sctollTo = $('.scroll-to');

  $('.scroll-to').on('click', function(event) {
    event.preventDefault();

    var animSpeed = 700;
    var $link = $(this);
    var hash = $link.attr('href');
    var $target = $(hash);

    if ($target.isset()) {
      $('html, body').stop().animate({
        'scrollTop': $target.offset().top - 140
      }, animSpeed, 'swing', function() {
        window.location.hash = hash;
      });
    }
  });

    // var $mainMenus = $('.main-menu');
  
    // if ($mainMenus.isset()) {
    //   $mainMenus.each(function() {
    //     var $menu = $(this);
    //     var $links = $menu.find('a[href^="#"]');
    //     var offset = parseInt($('.header__top').outerHeight());
    //     var animSpeed = 700;
  
    //     // Scroll on click
    //     $links.on('click', function(event) {
    //       event.preventDefault();
    //       var $link = $(this);
  
    //       var hash = $link.attr('href');
    //       var $target = $(hash);
  
    //       if ($target.isset()) {
    //         $('html, body').stop().animate({
    //           'scrollTop': $target.offset().top - offset - 20
    //         }, animSpeed, 'swing', function() {
    //           window.location.hash = hash;
    //         });
    //       }
  
    //     });
  
    //   });
    // }
  });


// WEBPACK FOOTER //
// ./main.js